import React from "react";
import { Grid, Container } from "@material-ui/core";
import BusinessFeatureItem from "./BusinessFeatureItem";

function BusinessFeatures({
  smDown,
  mdUp,
  lgUp,
  smUp,
  lgDown,
  xlUp,
  commonPadding,
}) {
  const businessFeatures = [
    {
      // name: "Find Realtors",
      name: "Collaborate with your Realtor",
      color: "#72cac9",
      image: "/images/home_page/Illustartion 18.svg",
      // description:
      //   "Simply search, compare, chat and connect with realtors based on their profiles, locations, reviews and areas of specialization.",
      description: "Using your homeownership hub, connect and collaborate with your realtor and all their preferred partners for a seamless homeownership experience.",
    },
    {
      // name: "Secure Financing",
      name: "Secure Home Financing",
      color: "#72cac9",
      image: "/images/home_page/Illustration 19.svg",
      // description:
      //   "Getting your mortgage approval just got easier. Use our platform to search and transact with independent mortgage brokers. Upload documents, e-sign contracts and fast-track your mortgage approval process.",
      description: "Getting your mortgage approval just got easier. Use your homeownership hub to search and transact with independent mortgage brokers. Upload documents, e-sign contracts and fast-track your mortgage approval process.",
    },
    {
      // name: "Connect with Lawyers",
      name: "Perform Virtual Closings with Lawyers",
      color: "#F37C61",
      image: "/images/home_page/Illustration 20.svg",
      // description:
      //   "Paperwork can be complicated. We help you find the right lawyers to complete all your closing documents and pay legal fees, without leaving your couch.",
      description: "Paperwork can be complicated. Connect and perform virtual closings with real estate lawyers to perform your closing, without leaving your couch.",
    },
    {
      // name: "Make your move",
      name: "Schedule your Move",
      color: "#F37C61",
      // image: "/images/home_page/Illustration 21.svg",
      image: "/images/home_buyers/Illustration 16.svg",
      // description:
      //   "Hurray! It's time to plan the move and get you into that dream home.",
      description: "Comprehensive self-serve support with all moving related tasks such as hiring a mover, scheduling services, transferring utilities, updating addresses, paying movers and live support from our team.",
    },
    {
      name: "Simplify Home Improvement Projects",
      color: "#F37C61",
      image: "/images/home_page/Illustration 21.svg",
      description: "Simply post your services request on Souqh, compare quotes from multiple home improvement professionals, schedule services, coordinate with vendors and securely pay using your homeownership hub.",
    },
  ];
  return (
    <Grid
      item
      container
      xs={12}
      style={{
        backgroundImage: lgUp
          ? "url('/images/home_buyers/Purple patch.svg'), url('/images/home_buyers/orange patch_right_2.svg')"
          : "none",
        backgroundRepeat: "no-repeat, no-repeat, no-repeat",
        backgroundSize: "10%, 7%",
        backgroundPosition: "0% 35%, 100% 35%",
        padding: commonPadding,
        marginTop: 20,
      }}
    >
      <Container>
        <Grid
          item
          xs={12}
          lg={12}
          container
          style={{ paddingBottom: smUp ? 40 : 0 }}
        >
          <Grid item container xs={12} style={{ justifyContent: "center" }}>
            {businessFeatures.map((item, index) => {
              return (
                <BusinessFeatureItem
                  key={index}
                  smDown={smDown}
                  mdUp={mdUp}
                  businessFeature={item}
                  isEven={index % 2 === 0}
                  lgUp={lgUp}
                  lgDown={lgDown}
                  xlUp={xlUp}
                  index={index}
                  smUp={smUp}
                />
              );
            })}
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
}

export default BusinessFeatures;
